<template>
  <div>
    <b-field class="form-contractor-switch" grouped>
      <b-switch
          class="enh-switch"
          v-model="turnedOn"
          position="is-right"
          type="is-green"
          >{{ title }}
      </b-switch>
      <b-select v-if="turnedOn" class="contractor-selector"
                v-model="mode"
      >
        <option
            v-for="mode in modes"
            :value="mode"
            :key="mode">
          {{ mode }}
        </option>
      </b-select>
    </b-field>
    <b-field v-if="mode === modes.isAnyOf" style="flex-wrap: wrap">
      <validation-provider vid="allowTaggingTiers">
      <b-field style="width: 100%">
        <b-checkbox v-model="allowTaggingTiers" :disabled="isDisabledTiers">
          Tier(s)
        </b-checkbox>
      </b-field>
      </validation-provider>
      <b-field
          v-if="allowTaggingTiers"
          style="width: 100%">
        <validation-provider v-slot="{ errors }"
                             :rules="{required: allowTaggingTiers}">
          <b-field :type="{ 'is-danger': errors.length }" :message="errors + [ '&nbsp;' ]">
            <taginput-modern
                v-model="taggedTiers"
                :data="filteredTiers"
                autocomplete
                :open-on-focus="true"
                field="name"
                @typing="getFilteredTags"
                @add="addedTier"
            >
            </taginput-modern>
          </b-field>
        </validation-provider>
      </b-field>
    </b-field>
    <b-field v-if="title === 'Additional user' &&
     mode === modes.isAnyOf" style="flex-wrap: wrap">
      <validation-provider name="sectionCheckbox"
                           mode="aggressive"
                           v-slot="{ errors }"
                           :rules="{requiredIfNotChecked:'@allowTaggingTiers'}">
        <b-field>
          <b-checkbox class="has-text-weight-normal" v-model="allowTaggingSections">
            Section(s)
          </b-checkbox>
        </b-field>
        <span class="help" :class="{'is-danger': errors.length > 0}">{{ errors[0] }}</span>
      </validation-provider>
      <b-field
          v-if="allowTaggingSections"
          style="width: 100%">
        <validation-provider name="Sections" v-slot="{ errors }"
                             :rules="{required: allowTaggingSections}">
          <b-field :type="{ 'is-danger': errors.length }" :message="errors + [ '&nbsp;' ]">
            <taginput-modern
                v-model="taggedSections"
                :data="filteredSections"
                field="name"
                autocomplete
                :open-on-focus="true"
                @typing="getFilteredSections"
                @add="addedSection"
            >
            </taginput-modern>
          </b-field>
        </validation-provider>
      </b-field>
    </b-field>
  </div>
</template>

<script>
import TaginputModern from '@/components/Taginput/TaginputModern.vue';

export default {
  name: 'ReleaseNoteGroup',
  components: {
    TaginputModern,
  },
  props: {
    title: {
      type: String,
      default: () => '',
    },
    tiers: {
      type: Array,
      default: () => [],
    },
    sections: {
      type: Array,
      default: () => [],
    },
    releaseNote: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      turnedOn: false,
      mode: 'any',
      modes: {
        any: 'any',
        isAnyOf: 'is any of...',
      },
      titles: {
        contractor: 'Contractor',
        additionalUser: 'Additional user',
      },
      taggedTiers: [],
      taggedSections: [],
      allowTaggingTiers: false,
      allowTaggingSections: false,
      isDisabledTiers: false,
    };
  },
  watch: {
    turnedOn() {
      if (!this.turnedOn) {
        if (this.mode !== this.modes.any) this.mode = this.modes.any;
        if (this.taggedTiers.length > 0) this.taggedTiers = [];
        if (this.taggedSections.length > 0) this.taggedSections = [];
      }
      this.$emit('change-switch', this.turnedOn);
    },
    mode() {
      if (this.mode === this.modes.any) {
        this.taggedTiers = [];
        this.taggedSections = [];
        this.allowTaggingTiers = false;
        this.allowTaggingSections = false;
      }
      if (this.turnedOn && this.title === this.titles.contractor
          && this.mode === this.modes.isAnyOf) {
        this.allowTaggingTiers = true;
        this.isDisabledTiers = true;
      }
    },
    taggedTiers() {
      this.$emit('change-tagged-tiers', this.taggedTiers);
    },
    taggedSections() {
      this.$emit('change-tagged-sections', this.taggedSections);
    },
    allowTaggingTiers() {
      if (!this.allowTaggingTiers) this.taggedTiers = [];
    },
    allowTaggingSections() {
      if (!this.allowTaggingSections) this.taggedSections = [];
    },
  },
  computed: {
    filteredTiers() {
      return this.tiers.filter(
        (tier) => this.taggedTiers.findIndex(
          (taggedTier) => taggedTier.name === tier.name,
        ) === -1,
      );
    },
    filteredSections() {
      return this.sections.filter(
        (section) => this.taggedSections.findIndex(
          (taggedSection) => taggedSection.name === section.name,
        ) === -1,
      );
    },
  },
  mounted() {
    if (this.releaseNote) {
      const { recipient } = this.releaseNote;
      if (recipient) {
        this.isManager = recipient.manager;
        if (this.title === this.titles.contractor) {
          if ('contractor' in recipient) {
            this.turnedOn = true;
            if (recipient.contractor.tiers && recipient.contractor.tiers.length > 0) {
              this.mode = this.modes.isAnyOf;
              this.taggedTiers = recipient.contractor.tiers.map(
                (tierName) => this.tiers.find(
                  (tierObj) => tierObj.name === tierName,
                ),
              );
            }
          }
        }
        if (this.title === this.titles.additionalUser) {
          if ('additionalUser' in recipient) {
            this.turnedOn = true;
            if (recipient.additionalUser.tiers && recipient.additionalUser.tiers.length > 0) {
              this.mode = this.modes.isAnyOf;
              this.allowTaggingTiers = true;
              this.taggedTiers = recipient.additionalUser.tiers.map(
                (tierName) => this.tiers.find(
                  (tierObj) => tierObj.name === tierName,
                ),
              );
            }
            if (recipient.additionalUser.sections
            && recipient.additionalUser.sections.length > 0) {
              this.mode = this.modes.isAnyOf;
              this.allowTaggingSections = true;
              this.taggedSections = recipient.additionalUser.sections.map(
                (sectionName) => this.sections.find(
                  (sectionObj) => sectionObj.name === sectionName,
                ),
              ).filter((item) => item);
            }
          }
        }
      }
    }
  },
  methods: {
    getFilteredTags(text) {
      if (text == null) {
        return;
      }
      this.$emit('filtering-tiers', text);
    },
    getFilteredSections(text) {
      if (text == null) {
        return;
      }
      this.$emit('filtering-sections', text);
    },
    addedTier() {
      this.taggedTiers.forEach((item) => {
        const idx = this.filteredTiers.findIndex(
          (selectedValue) => selectedValue.name === item,
        );
        if (idx !== -1) {
          this.filteredTiers.splice(idx, 1);
        }
      });
      this.$emit('filtering-tiers', '');
    },
    addedSection() {
      this.taggedSections.forEach((item) => {
        const idx = this.filteredSections.findIndex(
          (selectedValue) => selectedValue.name === item,
        );
        if (idx !== -1) {
          this.filteredSections.splice(idx, 1);
        }
      });
      this.$emit('filtering-sections', '');
    },
  },
};
</script>

<style scoped lang="stylus">
</style>
